import { render } from "./News.vue?vue&type=template&id=7951fec3&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=7951fec3&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\leeno\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7951fec3"]])

export default __exports__